export default "__VITE_PUBLIC_ASSET__8c69110e__"